import React from "react";

function ProfileAvatar({ user = {}, className = "", textClassName = "" }) {
  const userName = user?.name || "User";
  const profileImage =
    user?.profilePicUrl ||
    user?.profileImage ||
    user?.photoURL ||
    user?.picture ||
    "";

  const initials = userName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  const hasImage =
    profileImage && profileImage !== "NA" && profileImage !== "null";

  if (hasImage) {
    return (
      <img
        src={profileImage}
        alt={userName}
        referrerPolicy="no-referrer"
        className={`block rounded-full object-cover border-2 border-white ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center rounded-full border-2 border-white bg-gradient-to-br from-[#FF7A45] to-[#7B35D8] font-bold text-white ${className} ${textClassName}`}
      aria-label={userName}
    >
      {initials || "U"}
    </div>
  );
}

export default ProfileAvatar;
